import React from 'react';
import {
  FaComments,
  FaChartLine,
  FaHandshake,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="flex flex-col-reverse md:flex-row items-center justify-between px-4 sm:px-6 md:px-20 py-8 sm:py-10 min-h-[70vh] font-sans bg-[#fcfeff]">
      {/* Left Content */}
      <div className="w-full md:w-1/2 text-center md:text-left">
        <h1 className="text-xl sm:text-3xl md:text-4xl font-extrabold text-[#1b1d3c] leading-tight mb-4 md:mb-6">
          Let’s <span className="text-[#fc3c04]">Supercharge</span> Your Career  <span></span>
          <br className="hidden md:block" />
            with <span className="text-[#345bf3]">Foict</span>
        </h1>

        <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-5 md:mb-6 max-w-xl mx-auto md:mx-0">
          Foict is the only Career Accelerator Program that is Created by the industry experts for industry aspirants on a real time basis.
        </p>

        {/* Stats Section */}
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:gap-6 mb-6 items-center md:items-start">
          <div className="flex items-start space-x-3 max-w-xs">
            <FaComments className="text-[#fbeb04] text-xl mt-1" />
            <div>
              <p className="text-lg font-semibold text-gray-800">Soft Skills</p>
            </div>
          </div>
          <div className="flex items-start space-x-3 max-w-xs">
            <FaChartLine className="text-[#fbeb04] text-xl mt-1" />
            <div>
              <p className="text-lg font-semibold text-gray-800">Advanced Manager Skills</p>
            </div>
          </div>
          <div className="flex items-start space-x-3 max-w-xs">
            <FaHandshake className="text-[#fbeb04] text-xl mt-1" />
            <div>
              <p className="text-lg font-semibold text-gray-800">Enterprise Sales Leadership Skills</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="flex justify-center md:justify-start">
          <Link to={"/contact"} className="bg-[#fc3c04] text-white px-6 py-3 rounded-md font-medium shadow hover:bg-[#345bf3] transition-all duration-200">
            Enquire Now
          </Link>
        </div>
      </div>

      {/* Right Image */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end mb-10 md:mb-0">
        <img
          src="/Images/foictheroimag.png"
          alt="career promotion"
          className="w-full max-w-[300px] sm:max-w-[400px] object-contain drop-shadow"
        />
      </div>
    </section>
  );
};

export default HeroSection;
